import React from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';

const ResetSuccess = ({ onSwitchToLogin }) => {
  const { t } = useLanguage();
  return (
    <Card className="auth-card" style={{ maxWidth: '420px', width: '100%' }}>
      <Card.Body className="p-4 p-md-5 text-center">
        <div className="icon-circle bg-success bg-gradient mx-auto mb-3">
          <i className="bi bi-check-lg text-white"></i>
        </div>
        <h2 className="fw-bold">{t('resetSuccess.title')}</h2>
        <p className="text-muted mb-4">{t('resetSuccess.message')}</p>

        <Alert variant="success" className="text-start">
          <div className="d-flex">
            <i className="bi bi-check-circle-fill me-2 mt-1"></i>
            <div>
              {t('resetSuccess.info')}
            </div>
          </div>
        </Alert>

        <Button
          className="btn-gradient w-100 py-2 mt-3"
          size="lg"
          onClick={onSwitchToLogin}
        >
          {t('resetSuccess.continueToSignIn')}
        </Button>
      </Card.Body>
    </Card>
  );
};

export default ResetSuccess;
